import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { auth0WebAuth } from 'modules/boot/sso';
import { SocialButtonsPane, SignupPane } from '../index';

class SignupForm extends Component {
  state = {
    onClickGithubProvider: () => {},
    onClickGoogleProvider: () => {},
    onClickMicrosoftProvider: () => {},
    onClickDatabaseProvider: () => {},
    showPasswordPolicy: false,
    showSocialButtons: true
  };

  componentDidMount() {
    this.clientInitialize();
  }

  clientInitialize() {
    const { dbConnectionName } = this.props;

    this.setState({
      onClickGithubProvider: () => auth0WebAuth.authorize({ connection: 'github' }),
      onClickGoogleProvider: () => auth0WebAuth.authorize({ connection: 'google-oauth2' }),
      onClickMicrosoftProvider: () => auth0WebAuth.authorize({ connection: 'windowslive' }),
      onClickDatabaseProvider: (username, password, onError) => {
        auth0WebAuth.redirect.signupAndLogin(
          {
            email: username,
            password,
            connection: dbConnectionName
          },
          onError
        );
      }
    });
  }

  // babel next.es sugar to avoid writing constructur
  onInputFocus = this.onInputFocus.bind(this);
  onInputFocus() {
    this.setState({
      showPasswordPolicy: true,
      showSocialButtons: false
    });
  }
  // babel next.es sugar to avoid writing constructur
  onInputBlur = this.onInputBlur.bind(this);
  onInputBlur() {
    this.setState({
      showPasswordPolicy: false,
      showSocialButtons: true
    });
  }

  render() {
    const pwPolicy =
      this.state.showPasswordPolicy === false
        ? []
        : [
            { text: 'Be at least 8 characters in length', regex: /.{8,}/ },
            { text: 'Contain lowercase letters (a-z)', regex: /[a-z]/ },
            { text: 'Contain uppercase letters (A-Z)', regex: /[A-Z]/ },
            { text: 'Contain numbers (0-9)', regex: /[0-9]/ }
          ];

    return (
      <div
        className={`signup-form--container ${
          this.state.showSocialButtons === true ? 'hiding-policy' : 'showing-policy'
        }`}
      >
        <div className="form-box">
          <form className="sign-up-form">
            <SignupPane
              onSignup={this.state.onClickDatabaseProvider}
              onInputFocus={this.onInputFocus}
              onInputBlur={this.onInputBlur}
              passwordPolicy={pwPolicy}
            />
            <div className="divider">
              <div className="copy-separate">
                {(this.state.showSocialButtons && <p>or</p>) || (
                  <p>
                    <a>more options</a>
                  </p>
                )}
              </div>
            </div>
            <div
              className={`social-buttons--container ${
                this.state.showSocialButtons === true ? 'showing' : 'hiding'
              }`}
            >
              <SocialButtonsPane
                onClickGithubProvider={this.state.onClickGithubProvider}
                onClickGoogleProvider={this.state.onClickGoogleProvider}
                onClickMicrosoftProvider={this.state.onClickMicrosoftProvider}
              />
            </div>
          </form>
        </div>
        <style>{`
          .signup-form--container {
            box-shadow: 0 0 30px 0 rgba(0,0,0,0.1);
          }
          .sign-up-form {
            transition-property: min-height;
            transition-duration: .8s;
            transition-delay: .4s;
          }
          @media (min-width: 992px) {
            .signup-form--container.showing-policy .sign-up-form {
              min-height: 710px;
            }
            .signup-form--container.hiding-policy .sign-up-form {
              min-height: 720px;
            }
          }
          @media (max-width: 991px) {
            .signup-form--container.showing-policy .sign-up-form {
              min-height: 752px;
            }
            .signup-form--container.hiding-policy .sign-up-form {
              min-height: 672px;
            }
          }
          .signup-form--container .form-box .sign-up-form .copy-separate a {
            cursor: pointer;
          }
          .social-buttons--container {
            transition-property: opacity, visibility, height;
            transition-duration: .5s, .8s;
          }
          .social-buttons--container.showing {
            transition-delay: .4s;
            opacity: 1;
            visibility: visible;
          }
          @media (min-width: 992px) {
            .social-buttons--container.showing {
              height: 199px;
            }
          }
          @media (max-width: 991px) {
            .social-buttons--container.showing {
              height: 101px;
            }
          }
          .social-buttons--container.hiding {
            opacity: 0;
            visibility: hidden;
            height: 0px;
          }
          .social-buttons--container.hiding .button-wrapper button.auth0-lock-social-button {
            height: 0px
          }
        `}</style>
      </div>
    );
  }
}

SignupForm.propTypes = {
  dbConnectionName: PropTypes.string.isRequired
};

export default SignupForm;



// WEBPACK FOOTER //
// ./src/modules/signupForm/ab-show-password-policy/components/SignupForm/SignupForm.js